import { Component, OnInit, Injector, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { TelemedStateActionService } from '../statemanagement/telemed-state-action.service';
import { NotificationService } from '../../../claim/services/notification.service';
import { RenewService } from '../services/renew.service';
import { TelemedService } from '../services/telemed.service';
import { AddTags } from '../models/telemed.model';
import { BaseComponents } from '../../../base.component';
import { LineNotificationService } from '../services/line-notification.service';
import { InsuranceService } from '../services/insurance.service';
import { PortfolioInsuranceInterface } from '../models/portfolio-insurance.interface';
import { FormVerifyCustomerService } from '../services/form-verify-customer.service';
import { ResponseStateRegistration } from '../models/verify.model';
import { ReferenceService } from 'src/app/services/reference.service';
import { GetMaskingService } from 'src/app/adapters/getMasking.service';
 
import liff from '@line/liff';
import { CommonService } from '../services/common.service';
@Component({
    selector: 'app-completed',
    templateUrl: './completed.component.html',
    styleUrls: ['./completed.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompletedComponent extends BaseComponents implements OnInit {
  comCode: string = "insure";
  message: string = '';
  content = signal<any>({
    header: "สมัครใช้บริการสำเร็จ",
    body: ["ระบบกำลังส่งท่านกลับไปยังห้องสนทนา"]
  });
  isLocation: boolean = false;
  state = "";
  code = signal<string>("");
  flow: number | undefined;
  linkMessage = signal<string>('กลับไปยังห้องสนทนา');
  connectRef: string = '';
  showTextDefault = signal<boolean>(false);
  showTextRedirectPort =  signal<boolean>(false);
  log_session_text: string = "completed";
  referenceUUID: string | null = null;
  showTextRedirectExternal = signal<boolean>(false);
  isProcessRedirect = false;
  constructor(
    protected injectorObj: Injector,
    private route: ActivatedRoute,
    private lineStateAction: LineStateActionService,    
    private router: Router,
    private telemedStateActionService:TelemedStateActionService,
    private notificationService: NotificationService,
    private renewService:RenewService,
    private telemedService:TelemedService,
    private LineNotificationService: LineNotificationService,
    private insuranceService: InsuranceService,
    private verifyCustomerService: FormVerifyCustomerService,
    private referenceService:ReferenceService,
    public getMaskingService:GetMaskingService,
    private commonService: CommonService

  ) { 
    super(injectorObj);
  }


  async ngOnInit() {
    const funcName = "ngOnInit";
    try{
      this.referenceUUID = this.referenceService.getReferenceUUID();
      this.log_session_text = `completed referenceUUID:[${this.referenceUUID}]`;
      const channel = this.lineStateAction.channelStateInfo;
      this.logger.info(`${this.log_session_text} ${funcName} channel:${JSON.stringify(channel)}`);
      this.route.queryParams
        .subscribe(async (params) => {
          const status = params.status;
          const log_params = params ? JSON.stringify(params) : null;
          this.logger.info(`${this.log_session_text} ${funcName} params:${log_params}`);
          const substatus = params.substatus;        
          this.logger.info(`${this.log_session_text} ${funcName} registerFlow:${params?.registerFlow}`);
          if(params?.registerFlow === "portfolio"){
            this.logger.info(`${this.log_session_text} ${funcName} registerFlow == portfolio`);
            channel.registerFlow = params.registerFlow;
            channel.comCode = params.comcode;
            this.comCode = channel?.comCode ?? "insure";
            channel.liffId = params.appRef;
            channel.lineBotId = params.lineBotId;
          }
          this.connectRef = params.connectRef
          this.isProcessRedirect = channel?.campaign === 'FORD_2026_COUPON' ? true :  false;
          this.setContents(status, substatus)
          this.code.set(params.code);
          const electronic_channel = channel?.electronic_channel
          const lead_ref_number = params.ref
          // const channel_identity = channel?.channel_identity
          const liff_motor = params.liff_motor
          this.flow = params.flow
          const classify_insure = params.classify_insure   
          this.logger.info(`${this.log_session_text} complete status ${status}`);  
          if (channel?.registerFlow == "renew") {
            this.logger.info(`${this.log_session_text} ${funcName} channel.registerFlow == renew start`);
            this.logger.info(`${this.log_session_text} State Complete flow2 => params : ${log_params}`)
            this.logger.info(`${this.log_session_text} State Complete flow2 => electronic_channel : ${electronic_channel}`)
            this.logger.info(`${this.log_session_text} State Complete flow2 => lead_ref_number : ", ${lead_ref_number}`)
            // this.logger.info(["State Complete flow2 => channel_identity : ", channel_identity])
            this.logger.info(`${this.log_session_text} State Complete flow2 => liff_motor : ${liff_motor}`)
            this.logger.info(`${this.log_session_text} State Complete flow2 => flow :  ${this.flow}`)
            this.logger.info(`${this.log_session_text} State Complete flow2 => classify_insure :  ${classify_insure}`)
            channel.liff_portfolio = null;
            const bodyPushFlexMessageRenew = {
              electronic_channel : electronic_channel, 
              lead_ref_number : lead_ref_number, 
              liff_motor : liff_motor, 
              classify_insure : classify_insure,
              sub_channel: channel?.subChannel
            }
            await this.renewService.pushFlexMessageRenew(bodyPushFlexMessageRenew)
            .subscribe(async (result) => {
                this.logger.info(`${this.log_session_text} State Complete flow2 => response_code => : ${result?.response_code}`)
                this.logger.info(`${this.log_session_text} State Complete flow2 => response_desc => : ${result?.response_desc}`)
            });
          } else if(channel?.registerFlow == "claim"){
            this.logger.info(`${this.log_session_text} ${funcName} channel.registerFlow == claim`);
            let bodyInvite = {
              type:"line",
              service_code:2,
              line_channel:channel?.electronic_channel,   
              accident_no: channel?.accident_no,
              line_liff_register:channel?.liffId,
              rm_channel_id:channel?.rm_channel_id
            }
            this.logger.info(`${this.log_session_text} bodyInvite ${JSON.stringify(bodyInvite)}`);
            this.notificationService.apiPushMessageInvite(bodyInvite).subscribe(res => 
              this.logger.info(`${this.log_session_text} line register notify invite status: ${JSON.stringify(res)}`));
          }  
            
          });
       if(channel?.campaign === 'FORD_2026_COUPON') {
        this.logger.info(`${this.log_session_text} coupon have value:${channel.campaign}`);
        const request = { description: "CampaignConfig", id: null };
        const coupon = channel.campaign;
        this.showTextRedirectExternal.set(true);
        await this.verifyRegister();
        if (!this.isProcessRedirect) {
          this.logger.info(`${this.log_session_text} setContents status notfound substatus short set content header`);
          this.content.set({
          header: "ขออภัยไม่พบข้อมูลของท่าน",
          body : ["อีกหนึ่งช่องทางเข้าสู่บริการออนไลน์เพียง"]
        })       
          this.linkMessage.set("คลิก");
          return null;
        }
        this.commonService.apiGetCommonConfig(request).subscribe({
          next: (response) => {
            const jsonParse = JSON.parse(response.data.value);
            if (jsonParse && jsonParse[coupon]) {
              const path = jsonParse[coupon];
              this.logger.info(`${this.log_session_text} redirect to external url`);
              return window.location.href = path;
            } else {
              this.logger.error(`${this.log_session_text} ${funcName} common config not match campaign`);
            }
          },
          error: (e) => {
            this.logger.error(`${this.log_session_text} ${funcName} fatal error:${e.message}`);
            return null;
          },
        });
     
      } else if(channel?.campaign) {
        this.logger.info(`${this.log_session_text} campaign have value:${channel.campaign}`);
        const request = { description: "CampaignConfig", id: null };
        const campaign = channel.campaign;
        this.showTextRedirectExternal.set(true);
        this.commonService.apiGetCommonConfig(request).subscribe({
          next: (response) => {
            const jsonParse = JSON.parse(response.data.value);
            if (jsonParse && jsonParse[campaign]) {
              const result = jsonParse[campaign];
              this.logger.info(`${this.log_session_text} redirect to external url`);
              return window.location.href = result;
            } else {
              this.logger.error(`${this.log_session_text} ${funcName} common config not match campaign`);
            }
          },
          error: (e) => {
            this.logger.error(`${this.log_session_text} ${funcName} fatal error:${e.message}`);
            return null;
          },
        });
        
      } else if(channel?.liff_portfolio) {
        this.logger.info(`${this.log_session_text} ${funcName} channel.liff_portfolio have value verifyRegister Start`);
        await this.verifyRegister()
      } else {
        this.logger.info(`${this.log_session_text} ${funcName} channel.liff_portfolio not have value`);
        this.showTextDefault.set(true);
      }
      this.logger.info(`${this.log_session_text} ${funcName} addTag start`);
      this.addTag();
      this.logger.info(`${this.log_session_text} ${funcName} addTag end`);
      if (channel?.registerFlow == "telemed") {
        this.logger.info(`${this.log_session_text} ${funcName} channel.registerFlow == telemed goto page dazFormComplete`);
        return await this.router.navigate(["./dazFormComplete"], { relativeTo: this.route });
      }
      
    }catch(error){
      this.logger.error(`${this.log_session_text} ${funcName} error: ${error?.message}`);
      this.router.navigate(["register/line/"+this.comCode+"/form-error"], { queryParams: { "status": "apifail", "code": "" } })
    }
  }

  setContents(status:string, substatus = null) {
    this.logger.info(`${this.log_session_text} setContents status:${status} substatus:${substatus}`);
    if(this.isProcessRedirect) {
        this.logger.info(`${this.log_session_text} redirect page`);
        this.content.set({
          header: "ระบบกำลังดำเนินการ",
          body : ["กรุณารอสักครู่"]
        })
      return;
    }
    if (status == 'fail') {
    this.logger.info(`${this.log_session_text} setContents status fail set content header`);
      this.content.update(current => ({
        ...current,
        header : "สมัครใช้บริการไม่สำเร็จ"
      }));
      return;
    }
    if (status == 'notfound') {
    this.logger.info(`${this.log_session_text} setContents status notfound set content header`);
    this.content.set({
      header: "สมัครใช้บริการไม่สำเร็จ",
      body : ["ขณะนี้ท่านไม่สามารถดูข้อมูลได้ชั่วคราว", "กรุณาลองใหม่อีกครั้ง"]
    })
      if (substatus == 'short') {
        this.logger.info(`${this.log_session_text} setContents status notfound substatus short set content header`);
        this.content.set({
          header: "ขออภัยไม่พบข้อมูลของท่าน",
          body : ["อีกหนึ่งช่องทางเข้าสู่บริการออนไลน์เพียง"]
        });
        this.linkMessage.set("คลิก");
      }
      return;
    }
    if (status == 'apifail') {
      this.logger.info(`${this.log_session_text} setContents status fail set content header`);
      this.content.set({
        header : "ระบบเกิดข้อผิดพลาด",
        body : ["ขออภัยในความไม่สะดวกเนื่องจากพบปัญหาในการเชื่อมต่อข้อมูล กรุณาทำรายการใหม่อีกครั้ง"]
      });
      return;
    }
    
    if(status == 'success'){
      this.logger.info(`${this.log_session_text} setContents status success close liff`);
      setTimeout(()=>{
        liff.closeWindow();
      },5000)      
    }
  }

  addTag(){
    this.logger.info(`${this.log_session_text} addTag start`);
    const channel = this.lineStateAction.channelStateInfo;
    this.logger.info(`${this.log_session_text} addTag channel?.addTag:${channel?.addTag}`);
    if(channel?.addTag){
      this.logger.info(`${this.log_session_text} addTag addTagRef start`);
      this.addTagRef([channel?.addTag]);
    }
  }
  async addTagRef(tags: Array<string>) {
    const channel = this.lineStateAction.channelStateInfo;
    let payloadAddTags: AddTags = {
      // "channel_identity": channel?.channel_identity,
      "electronic_channel": channel?.electronic_channel,
      tags: []
    }
    tags.forEach(val => {
      payloadAddTags.tags.push({ "tagRef": val })
    })
    this.logger.info(`${this.log_session_text} addTagRef payloadAddTags:${JSON.stringify(payloadAddTags)}`);
    this.logger.info(`${this.log_session_text} addTag apiAddTagRef start`);
    return this.telemedService.apiAddTagRef(payloadAddTags).subscribe();
  }

  async closeLiff() {
    const funcName = "closeLiff";
    try {      
      this.logger.info(`${this.log_session_text} ${funcName} start`);
      const channel = this.lineStateAction.channelStateInfo;    
      await liff.init({ liffId: channel?.liffId ?? "" });

      if (this.isOpenWithExternalLink()) {
        this.logger.info(`${this.log_session_text} ${funcName} isOpenWithExternalLink true`);
        window.location.href = 'https://line.me/R/oaMessage/' + channel?.lineBotId
        return;
      }
      if (channel?.registerFlow === "renew") {
        console.log(['No auto message on flow renew']);
        this.logger.info(`${this.log_session_text} ${funcName} channel.registerFlow === renew,No auto message on flow renew`);
        window.location.href = 'https://line.me/R/oaMessage/' + channel?.lineBotId
      } else if (channel?.registerFlow === "claim") { 
        console.log(['No auto message on flow claim']); 
        this.logger.info(`${this.log_session_text} ${funcName} channel.registerFlow === claim,No auto message on flow claim`);
        window.location.href = 'https://line.me/R/oaMessage/' + channel?.lineBotId
      } else {
        this.logger.info(`${this.log_session_text} ${funcName} flow other`);
        if (channel && channel?.isLocation) {
          this.logger.info(`${this.log_session_text} ${funcName} flow isLocation true`);
          let message = "ค้นหาศูนย์บริการซ่อมสีและตัวถัง";
          if (channel && (channel?.comCode == "mazda")) {
            this.logger.info(`${this.log_session_text} ${funcName} flow isLocation comCode mazda`);
            message = "ค้นหาศูนย์ซ่อมตัวถังและสีมาตรฐาน";
          } else if (channel && (channel?.comCode == "nissan")) {
            this.logger.info(`${this.log_session_text} ${funcName} flow isLocation comCode nissan`);
            message = "ค้นหาศูนย์ซ่อมสีและตัวถังมาตรฐาน";
          }
          this.logger.info(`${this.log_session_text} ${funcName} flow isLocation case register location message:${message}`);
          console.log(['case register location', message]);
          await liff.sendMessages([
            {
              type: 'text',
              text: message
            }
          ]);
          liff.closeWindow();
        } else {
          this.logger.info(`${this.log_session_text} ${funcName} flow look portfolio`);
          let message = "ข้อมูลประกันภัยของท่าน";
          if (channel && (channel?.comCode == "mazda" || channel?.comCode == "ford" || channel?.comCode == "nissan")) {
            if(channel?.message){
              message = decodeURIComponent(channel?.message);
              this.logger.info(`${this.log_session_text} ${funcName} flow look portfolio motor have message:${channel?.message}`);
            }else{
              this.logger.info(`${this.log_session_text} ${funcName} flow look portfolio motor not have message`);
              message = "ข้อมูลประกันภัยรถยนต์ของท่าน";
            }

          }
          this.logger.info(`${this.log_session_text} ${funcName} flow look portfolio send message:${message}`);
          await liff.sendMessages([
            {
              type: 'text',
              text: message
            }
          ]);
          liff.closeWindow();
        }

      }

    } catch (err) {
      this.logger.error(`${this.log_session_text} closeLiff error:${err?.message}`);
      console.error(err);
    }
  }

  // กรณีที่ไม่ได้มาจากการกด link ที่ได้จาก line จะไม่สามารถใช้ feature liff.sendMessage() ได้ 
  // เช่น qr-code ,sms
  isOpenWithExternalLink(): boolean {
    const context = liff.getContext();
    if (context && context.type == "utou") {
      return false;
    }
    return true;
  }

  decryptData(re_data) {
    if (re_data != "" && re_data != null) {
        let result = JSON.parse(
            decodeURIComponent(
                Array.prototype.map.call(
                    atob(this.decryptData(re_data)), function (c) {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
                    }).join('')
            )
        )
      
      return result;
    }
  }
  mockLocalLine = {
    userId: "",
  };

  async checkPortfolio(){
    const funcName = "checkPortfolio";
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    const channel = this.lineStateAction.channelStateInfo;    
    await liff.init({ liffId: channel?.liffId });
    // let profile = await liff.getProfile();
    // let profile = this.mockLocalLine;
    const body = {
      // ucid: profile.userId,
      electronic_channel: channel?.electronic_channel,
      comcode: channel?.comCode,
    };
    this.logger.info(`${this.log_session_text} ${funcName} body:${JSON.stringify(body)}`);
    await this.insuranceService
          .getList(body)
          .subscribe(async (res: PortfolioInsuranceInterface) => {
            let motor = res?.motor;
            let non_motor = res?.non_motor;
            this.logger.info(`${this.log_session_text} motor port length: ${motor.length}`)
            this.logger.info(`${this.log_session_text} non_motor port length: ${non_motor.length}`)
            if(motor.length > 0 || non_motor.length > 0 ){
              this.showTextRedirectPort.set(true);
              this.logger.info(`${this.log_session_text} have portfolio redirect to portfolio`)
              window.location.href = `https://liff.line.me/${channel?.liff_portfolio}?autoredirect=true&referenceUUID=${this.referenceUUID}`;
            } else {
              this.logger.info(`${this.log_session_text} not have portfolio`)
              this.showTextDefault.set(true);
            }
          }
      )
  }

  async verifyRegister() { 
    const funcName = "verifyRegister";
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    const channel = this.lineStateAction.channelStateInfo;  
    // await liff.init({ liffId: channel?.liffId });
    // let profile = await liff.getProfile();  
    const payload = {
      // channel_identity: profile.userId,
      application_channel_reference: this.isProcessRedirect ? null : channel.application_channel_reference,
      electronic_channel: channel.electronic_channel,
    };
    this.logger.info(`${this.log_session_text} ${funcName} call apiVerifyRegistration payload:${JSON.stringify(payload)}`);
    let result = await this.verifyCustomerService.apiVerifyRegistration(payload).first().toPromise()
    const log_result = result ? JSON.stringify(result) : null;
    this.logger.info(`${this.log_session_text} ${funcName} call apiVerifyRegistration result:${log_result}`);
    if (!result) return;
    const registerStatus = result.state_code;
    this.logger.info(`${this.log_session_text} ${funcName} check register status before check port : ${registerStatus}`)
    if(this.isProcessRedirect) {
      if(!(registerStatus == ResponseStateRegistration.REGISTERED_ALREADY || registerStatus == ResponseStateRegistration.PRE_REGISTERED)) {
        this.isProcessRedirect = false;
      }
    } else {
      if(registerStatus == ResponseStateRegistration.REGISTERED_ALREADY) {
        this.logger.info(`${this.log_session_text} ${funcName} check register checkPortfolio start`)
        await this.checkPortfolio()
        this.logger.info(`${this.log_session_text} ${funcName} check register checkPortfolio end`)
      }else {
        this.logger.info(`${this.log_session_text} ${funcName} check register flow not registered`)
        this.showTextDefault.set(true);
      }
    }
  }
}
